export default __webpack_public_path__ + "static/media/trade_requests.efb173c4.svg";